import { render } from "./AddObservation.vue?vue&type=template&id=8a30722c&scoped=true"
import script from "./AddObservation.vue?vue&type=script&lang=js"
export * from "./AddObservation.vue?vue&type=script&lang=js"

import "./AddObservation.vue?vue&type=style&index=0&id=8a30722c&scoped=true&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a30722c"]])

export default __exports__